// Warning! You can't add new media file processing status!
// See packages/media/media-core/src/__tests__/cache-backward-compatibility.spec.ts

export var isPreviewableType = function isPreviewableType(type) {
  var defaultPreviewableTypes = ['audio', 'video', 'image', 'doc'];
  return defaultPreviewableTypes.indexOf(type) > -1;
};
export var isNotFoundMediaItemDetails = function isNotFoundMediaItemDetails(itemDetails) {
  return 'type' in itemDetails && itemDetails.type === 'not-found';
};
export var DATA_UNIT = /*#__PURE__*/function (DATA_UNIT) {
  DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
  DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
  DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
  return DATA_UNIT;
}({});